<template>
	<div id="app">
		<transition name="fade"
		            mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'app',
	components: {
	}
}

</script>

<style lang="scss">
body {
	margin: 0px;
	padding: 0px;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
	background-image: url('https://aqjg.ycsyzglj.com/yhpc_gjbg.png');
    background-size:cover;
    background-repeat: repeat;
    background-position: center;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.toolbar {
	background: #f2f2f2;
	padding: 10px;
	//border:1px solid #dfe6ec;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 10px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

// 用于对话框里显示图片，一行2个
.image-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; /* 根据需要调整 */
}
 
.image-item {
  flex: 0 0 48%; /* 每个图片项占据大约48%的宽度 */
  margin-bottom: 2%; /* 根据需要调整 */
}
 
.image-item img {
  width: 100%;
  height: auto;
}

//用于详情显示
	.base-name {
	font-size: 20px;
	font-weight: 600;
	color: #1989fa;
	margin-bottom: 15px;
	}

	.base-info-row {
	display: flex;
	flex-direction: column;
	/* flex-wrap: wrap; */
	margin-bottom: 10px;
	}

	.info-item {
	margin-right: 30px;
	margin-bottom: 8px;
	font-size: 14px;
	}

	.label {
	color: #666;
	margin-right: 5px;
	}

	.value {
	color: #333;
	}
// end


</style>


// WEBPACK FOOTER //
// App.vue?12343a5c